// src/config/categorias.js
export const CATEGORIAS = [
  { id: "todos", nombre: "Todo", icono: "🛍️", color: "#FF6B35" },
  {
    id: "hogar-decoracion",
    nombre: "Hogar y Decoración",
    icono: "🏠",
    color: "#4ECDC4",
  },
  {
    id: "belleza-salud",
    nombre: "Belleza y Salud",
    icono: "💄",
    color: "#FF6B9D",
  },
  { id: "tecnologia", nombre: "Tecnología", icono: "💻", color: "#5B8AF0" },
  { id: "moda-ropa", nombre: "Moda y Ropa", icono: "👗", color: "#A855F7" },
  { id: "deportes", nombre: "Deportes", icono: "⚽", color: "#22C55E" },
  {
    id: "juguetes-bebes",
    nombre: "Juguetes y Bebés",
    icono: "🧸",
    color: "#F59E0B",
  },
  { id: "mascotas", nombre: "Mascotas", icono: "🐾", color: "#F97316" },
  { id: "automotriz", nombre: "Automotriz", icono: "🚗", color: "#64748B" },
  { id: "cocina", nombre: "Cocina", icono: "🍳", color: "#EF4444" },
  {
    id: "juegos-entretenimiento",
    nombre: "Juegos",
    icono: "🎮",
    color: "#8B5CF6",
  },
];

export const getCategoriaById = (id) => CATEGORIAS.find((c) => c.id === id);
